import { ReturnTypeEnum } from "@redotech/redo-model/return";
import {
  AssessmentFieldSchema,
  ReturnAssessmentWithDefinitionSchema,
} from "@redotech/redo-model/return-assessments/assessment-schemas";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const updateAssessment = {
  name: "updateAssessment" as const,

  input: z.object({
    assessmentId: zExt.objectId(),
    name: z.string().optional(),
    kind: z.enum(ReturnTypeEnum).optional(),
    fields: z.array(AssessmentFieldSchema),
    iconName: z.string().optional(),
    iconColor: z.string().optional(),
  }),

  output: ReturnAssessmentWithDefinitionSchema.nullable(),
};
